function u(e, n) {
  return e?.[n];
}
export {
  u as default
};
